module.exports = __webpack_public_path__ + "media/images/application2/Payments__card__right__top__default-3300683107b93790088e46e203a16863.svg";